
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersPolartwilight as ObiHeavyRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiHeavyRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-polartwilight',
   elementClass: ObiHeavyRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 